import { graphql } from 'gatsby'
import React from 'react'

import useSiteSettings from '../../../hooks/useSiteSettings'
import { AccountBodyPortableText } from './AccountBodyPortableText'

const ReturnPolicy: React.FC = () => {
  const { _rawReturnPolicyText: returnPolicyText } = useSiteSettings()
  return (
    <div>
      <h3 className="small-h3">Return Policy:</h3>
      <AccountBodyPortableText blocks={returnPolicyText} />
    </div>
  )
}

export const returnPolicyTextFragment = graphql`
  fragment returnPolicyText on SanitySiteSettings {
    _rawReturnPolicyText
  }
`

export default ReturnPolicy
